import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetBranchList } from '~/usecases/useGetBranchList';
import { useGetStressAssessmentSummary } from '~/usecases/useGetStressAssessmentSummary';
import { useGetStressAssessmentBranchStats } from './useGetStressAssessmentBranchStats';

type Branch = {
  id: number;
  label: string;
};

type IUseStressAssessmentReportDownload = () => {
  state: {
    data: ReturnType<typeof useGetBranchList>['data'];
    isLoading: boolean;
    selectedBranch: Branch | undefined;
    branchStats: ReturnType<typeof useGetStressAssessmentBranchStats>['data'];
    stressAssessmentSummary: ReturnType<typeof useGetStressAssessmentSummary>['data'];
  };
  actions: {
    handleSetBranch: (id: number) => void;
  };
};

export const useStressAssessmentReportDownload: IUseStressAssessmentReportDownload = () => {
  const threeLetterCode = getThreeLetterCode();
  const { id } = useParams();
  const stressAssessmentId = Number.parseInt(id, 10);

  // 現時点でpaginationの実装は想定していないためpageは1で固定
  // 今後必要になったタイミングで実装する
  const { data, isLoading: isLoadingBranchList } = useGetBranchList({ threeLetterCode, page: '1' });
  const [selectedBranch, setSelectedBranch] = useState<Branch | undefined>(undefined);

  // branchesが1つの場合は自動選択、複数の場合はユーザー選択を使用
  const computedSelectedBranch =
    data?.branches.length === 1
      ? { id: data.branches[0].id, label: data.branches[0].name }
      : selectedBranch;

  const { data: stressAssessmentSummary, isLoading: isLoadingSummary } =
    useGetStressAssessmentSummary(threeLetterCode, id);

  const { data: branchStats } = useGetStressAssessmentBranchStats(
    threeLetterCode,
    stressAssessmentId,
    computedSelectedBranch?.id,
    { swr: { enabled: !!computedSelectedBranch } }
  );

  const handleSetBranch = (id: number): void => {
    const selectedBranch = data?.branches.find(b => b.id === id);
    if (!selectedBranch) return;

    const branch = { id: selectedBranch.id, label: selectedBranch.name };
    setSelectedBranch(branch);
  };

  return {
    state: {
      data,
      isLoading: isLoadingBranchList || isLoadingSummary,
      selectedBranch: computedSelectedBranch,
      branchStats,
      stressAssessmentSummary,
    },
    actions: {
      handleSetBranch,
    },
  };
};
